import React from "react";
import { XAxis, Tooltip, ResponsiveContainer, ComposedChart, YAxis, Bar, Legend, Scatter } from "recharts";

export const PdpGraph = ({
  data
}) => {


  const renderTooltip = e => {
    if (e.label && e.payload) {
      return (
        <div className="major-channel-utilization-tooltip">
          <div className="major-channel-utilization-tooltip-heading">
            <span>DOD: {e.label?.toFixed(3)}</span>
          </div>
          <div className="major-channel-utilization-tooltip-data">
            {
              e.payload.map((item, ind) => (
                <span key={item.name + ind} style={{ color: item.color }}>
                  {item.name} : {item.value?.toFixed(3)}
                </span>
              ))
            }
          </div>
        </div>
      );
    } else {
      return '';
    }
  };
  return (
    <ResponsiveContainer height="100%" width="100%">
      <ComposedChart
        width={500}
        height={400}
        data={data}
        margin={{
          top: 20,
          right: 20,
          bottom: 20,
          left: 20
        }}
      >
        <XAxis
          dataKey="DOD"
          type='category'
          padding={{ left: 20, right: 20 }}
          tickLine={false}
          tickFormatter={(tick) => { return tick?.toFixed(3) }}
        />
        <YAxis tickLine={false} />
        <Tooltip content={e => renderTooltip(e)} />
        <Legend payload={
          [
            { id: 'estimated_lift', value: 'estimated_lift', type: 'square', color: '#0353a4' },
            { id: 'actual_lift', value: 'actual_lift', type: 'circle', color: '#e57d2f' },
          ]
        }
        />
        <Bar dataKey="estimated_lift" barSize={25} fill="#0353a4" isAnimationActive={false} />
        <Scatter dataKey="actual_lift" fill="#e57d2f" isAnimationActive={false} />
      </ComposedChart>
    </ResponsiveContainer>

  );
}
